import { useNavigate } from 'react-router-dom';
import { Activity, Store, ArrowRight } from 'lucide-react';

const SPORTS_BG = 'https://images.pexels.com/photos/8961886/pexels-photo-8961886.jpeg';

export default function IndustrySelectorPage() {
  const navigate = useNavigate();

  const handleSports = () => {
    // If already logged in to Sports, go straight to dashboard; otherwise login
    const hasSportsToken = localStorage.getItem('sports_token');
    navigate(hasSportsToken ? '/sports/dashboard' : '/sports/login');
  };

  return (
    <div className="min-h-screen w-full flex flex-col lg:flex-row" data-testid="industry-selector">
      {/* RETAIL — dark, emerald-accented business */}
      <button
        onClick={() => navigate('/login')}
        data-testid="select-retail"
        className="group relative flex-1 min-h-[45vh] lg:min-h-screen bg-[#0B0F0D] text-white px-8 sm:px-14 py-16 flex flex-col justify-center text-left transition-[flex] duration-500 lg:hover:flex-[1.15] overflow-hidden"
      >
        <div className="absolute inset-0 bg-gradient-to-br from-[#0B0F0D] via-[#0B0F0D] to-emerald-900/30" />
        <div className="absolute -left-24 top-1/3 h-72 w-72 rounded-full bg-emerald-500/10 blur-3xl group-hover:bg-emerald-500/20 transition-colors" />
        <div className="relative max-w-sm">
          <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-emerald-500 mb-6 shadow-[0_0_22px_rgba(16,185,129,0.5)]">
            <Store className="h-6 w-6 text-white" strokeWidth={1.9} />
          </span>
          <p className="text-xs font-semibold uppercase tracking-widest text-emerald-400">Retail System</p>
          <h2 className="mt-2 text-4xl sm:text-5xl font-bold tracking-tight leading-[1.05]">
            AgriBooks<br />Retail
          </h2>
          <p className="mt-4 text-white/70 text-base">
            Multi-branch POS, inventory, accounts receivable &amp; daily close for agri-retail.
          </p>
          <span className="mt-8 inline-flex items-center gap-2 text-emerald-400 font-semibold group-hover:gap-3 transition-all">
            Continue <ArrowRight className="h-4 w-4" />
          </span>
        </div>
      </button>

      {/* SPORTS — dark, energetic */}
      <button
        onClick={handleSports}
        data-testid="select-sports"
        className="group relative flex-1 min-h-[45vh] lg:min-h-screen bg-[#0A0A0A] text-white px-8 sm:px-14 py-16 flex flex-col justify-center text-left transition-[flex] duration-500 lg:hover:flex-[1.15] overflow-hidden"
        style={{ fontFamily: 'Manrope, sans-serif' }}
      >
        <img src={SPORTS_BG} alt="" className="absolute inset-0 h-full w-full object-cover opacity-30 group-hover:opacity-40 transition-opacity" />
        <div className="absolute inset-0 bg-gradient-to-br from-black/80 via-black/70 to-[#E63946]/25" />
        <div className="relative max-w-sm">
          <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#E63946] mb-6 shadow-[0_0_22px_rgba(230,57,70,0.55)]">
            <Activity className="h-6 w-6 text-white" strokeWidth={2.2} />
          </span>
          <p className="text-xs font-semibold uppercase tracking-widest text-[#E63946]">Sports Booking</p>
          <h2 className="mt-2 text-4xl sm:text-5xl uppercase tracking-tight leading-[1.02]" style={{ fontFamily: 'Oswald, sans-serif', fontWeight: 700 }}>
            AgriBooks<br />Sports
          </h2>
          <p className="mt-4 text-white/70 text-base">
            Court booking &amp; facility management. Your own customer site, smart availability, instant confirmations.
          </p>
          <span className="mt-8 inline-flex items-center gap-2 text-[#E63946] font-semibold group-hover:gap-3 transition-all">
            Enter <ArrowRight className="h-4 w-4" />
          </span>
        </div>
      </button>
    </div>
  );
}
